export enum CaseType {
  PDI = 'PDI',
  FLASH_ONLY = 'FLASH_ONLY',
}
